module.exports = __webpack_public_path__ + "img/question_icon.8a36d3fb.svg";